import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ThankYou from "@/pages/ThankYou";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Subscribers from "@/pages/Subscribers";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Bonuses from "@/pages/Bonuses";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";
import CookieConsent from "@/components/CookieConsent";
import SocialProofPopup from "@/components/SocialProofPopup";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/bonuses" element={<Bonuses />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
        <SocialProofPopup />
      </BrowserRouter>
    </div>
  );
}

export default App;
